import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import MainContainer from "../components/containers/MainContainer";

export default function NotFound() {
	return (
		<MainContainer>
			<Grid
				container
				style={{ backgroundColor: "transparent", height: "80vh" }}
				justify="center"
				alignItems="center"
			>
				<Grid item xs={12} style={{ textAlign: "center" }}>
					<Typography variant="h3">Page not Found</Typography>
					<br />
					<Link to="/">Go back to Home Page</Link>
				</Grid>
			</Grid>
		</MainContainer>
	);
}
